// @flow

import gql from "graphql-tag";
import { graphql } from "react-apollo";
import type { QueryProps } from "react-apollo";

import type { LimitKind } from "../utils/progress";

export type SessionType = {
  id: string,
  limitValue: number,
  limitKind: LimitKind,
  bonusCents: number,
  score: number,
  userId: string,
  projectId: string,
  assignmentId: string,
  maxBonusCents: number,
  basePayCents: number
};

// -----------------------------
// Create Session Mutation

const createSessionMutation = gql`
  mutation(
    $limitValue: Int!
    $limitKind: String!
    $projectId: ID!
    $userId: ID!
    $assignmentId: String
    $maxBonusCents: Int
    $basePayCents: Int
  ) {
    createSession(
      userId: $userId
      assignmentId: $assignmentId
      limitValue: $limitValue
      limitKind: $limitKind
      projectId: $projectId
      maxBonusCents: $maxBonusCents
      basePayCents: $basePayCents
    ) {
      id
    }
  }
`;

export type createSessionMutationResult = {
  data: {
    createSession: {
      id: string
    }
  }
};

export const withCreateSession = graphql(createSessionMutation, {
  name: "createSession"
});

// -----------------------------
// Update Session Mutation

const updateSessionMutation = gql`
  mutation($id: ID!, $bonusCents: Int, $score: Float!) {
    updateSession(id: $id, bonusCents: $bonusCents, score: $score) {
      id
      bonusCents
      score
    }
  }
`;

export type updateSessionMutationResult = {
  data: {
    updateSession: SessionType
  }
};

export const withUpdateSession = graphql(updateSessionMutation, {
  name: "updateSession"
});

// -----------------------------
// Complete Session Mutation

const completeSessionMutation = gql`
  mutation($id: ID!, $completed: Boolean!) {
    completeSession: updateSession(id: $id, completed: $completed) {
      id
      completed
    }
  }
`;

export type completeSessionMutationResult = {
  data: {
    completeSession: SessionType
  }
};

export const withCompleteSession = graphql(completeSessionMutation, {
  name: "completeSession"
});

// TODO: Add completeSessionType

// -----------------------------
// Extend Session Mutation

const extendSessionMutation = gql`
  mutation($id: ID!, $limitValue: Int!, $maxBonusCents: Int) {
    extendSession: updateSession(
      id: $id
      limitValue: $limitValue
      maxBonusCents: $maxBonusCents
    ) {
      id
      limitValue
      maxBonusCents
    }
  }
`;

export type extendSessionMutationResult = {
  data: {
    extendSession: SessionType
  }
};

export const withExtendSession = graphql(extendSessionMutation, {
  name: "extendSession"
});

// TODO: Add extendSessionType

// -----------------------------
// Session query

// TODO: Add filter based on updatedAt DateTime
// https://www.graph.cool/forum/t/filtering-by-datetime-range/391
const sessionQuery = gql`
  query SessionQuery($projectId: ID!) {
    user {
      id
      sessions(
        filter: { project: { id: $projectId }, completed: false }
        orderBy: createdAt_DESC
        first: 1
      ) {
        id
        limitKind
        limitValue
        bonusCents
        score
        completed
        maxBonusCents
        basePayCents
      }
    }
  }
`;

export type sessionQueryResult = {
  sessionData: {
    user: {
      id: string,
      sessions: Array<SessionType>
    }
  } & QueryProps
};

export const withSession = graphql(sessionQuery, {
  name: "sessionData"
});



// WEBPACK FOOTER //
// ./src/data/session.js